import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { fetchHeroMetaDataApi } from '../pages/HeroSaga/heroMetaDataSlice';

export default function useHeroMetaData() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { heroMetaData } = useSelector((state) => state.heroSaga);

    useEffect(() => {
        if (isEmpty(heroMetaData)) {
            dispatch(fetchHeroMetaDataApi(navigate));
        }
    }, []);

    return heroMetaData;
}
